// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_extension from "lui/lui_extension.js";
import * as Lui_protocol from "lui/lui_protocol.js";
import * as Lui_ui from "lui/lui_ui.js";
import * as Mapre_web__Web_scroll_input from "./web_scroll_input.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Option from "melange/option.js";

const identifier = "mapre-scroll-anchor";

function scroll_parent(el, _document) {
  const scope = el.closest("[data-anchor-scope]");
  const scoped = !(scope == null) ? Caml_option.nullable_to_opt(scope.querySelector("[data-scroll-root]")) : undefined;
  if (scoped !== undefined) {
    return Caml_option.some(Caml_option.valFromOption(scoped));
  }
  let _current = el;
  while (true) {
    const current = _current;
    const next = current.parentElement;
    if (next == null) {
      return;
    }
    const overflow = window.getComputedStyle(next).overflowY;
    if (overflow === "auto" || overflow === "scroll") {
      return Caml_option.some(next);
    }
    _current = next;
    continue;
  };
}

function at_bottom(root) {
  return root.clientHeight + root.scrollTop >= root.scrollHeight - 72;
}

function reach_top(state, root, older) {
  if (state.live && !state.follow && state.older_armed && root.scrollTop <= 72) {
    state.older_armed = false;
    return Curry._1(older, undefined);
  }
  
}

function bottom(root) {
  root.scrollTop = root.scrollHeight;
}

function create(_node, $$document, emit) {
  const el = $$document.createElement("span");
  el.setAttribute("data-scroll-anchor", "transcript");
  el.className = "scroll-anchor";
  const pinned = {
    contents: undefined
  };
  const report = function (value) {
    if (Caml_obj.caml_notequal(pinned.contents, value)) {
      pinned.contents = value;
      return Curry._2(emit, "pinned", Curry._2(Lui_protocol.String_map.singleton, "value", {
        TAG: /* BoolValue */ 1,
        _0: value
      }));
    }
    
  };
  const state = {
    report,
    scope: "",
    live: true,
    follow: true,
    dragging: false,
    last_top: 0,
    root: undefined,
    older_armed: false
  };
  el.__mapreAnchor = state;
  const installed = {
    contents: false
  };
  const attempts = {
    contents: 0
  };
  const try_install = function (param) {
    if (!(state.live && !installed.contents)) {
      return;
    }
    attempts.contents = attempts.contents + 1 | 0;
    const root = scroll_parent(el, $$document);
    if (root !== undefined) {
      installed.contents = true;
      let root$1 = Caml_option.valFromOption(root);
      let older = function (param) {
        Curry._2(emit, "older", Lui_protocol.String_map.empty);
      };
      state.root = Caml_option.some(root$1);
      const jump = function (param) {
        if (state.live) {
          if (state.follow) {
            bottom(root$1);
          }
          state.last_top = root$1.scrollTop;
          return;
        }
        
      };
      const on_scroll = function (param) {
        if (!state.live) {
          return;
        }
        const current = root$1.scrollTop;
        if (state.dragging) {
          state.follow = at_bottom(root$1);
        } else if (!state.follow && current > state.last_top && at_bottom(root$1)) {
          state.follow = true;
        }
        state.last_top = current;
        jump();
        reach_top(state, root$1, older);
        Curry._1(report, state.follow);
      };
      const away = function (param) {
        if (state.live && root$1.scrollHeight > root$1.clientHeight) {
          state.follow = false;
          state.older_armed = true;
          state.last_top = root$1.scrollTop;
          window.requestAnimationFrame(function (param) {
            reach_top(state, root$1, older);
          });
          return;
        }
        
      };
      const input = Mapre_web__Web_scroll_input.install(root$1, (function (param) {
        
      }), away, (function (dragging) {
        state.dragging = dragging;
        if (!dragging) {
          return on_scroll();
        }
        
      }));
      root$1.addEventListener("scroll", on_scroll);
      const watcher = new ResizeObserver(jump);
      watcher.observe(root$1);
      const spacer = root$1.firstElementChild;
      if (!(spacer == null)) {
        watcher.observe(spacer);
      }
      el.__mapreAnchorDispose = {
        dispose: (function (param) {
          state.live = false;
          Curry._1(input, undefined);
          root$1.removeEventListener("scroll", on_scroll);
          watcher.disconnect();
        })
      };
      jump();
      return Curry._1(report, state.follow);
    } else if (attempts.contents < 240) {
      window.requestAnimationFrame(try_install);
      return;
    } else {
      return;
    }
  };
  window.requestAnimationFrame(try_install);
  return el;
}

function set_property(el, key, property) {
  const state = el.__mapreAnchor;
  switch (key) {
    case "force" :
      switch (property.TAG) {
        case /* StringValue */ 0 :
        case /* BoolValue */ 1 :
          return Stdlib.invalid_arg("invalid_anchor_property");
        case /* IntValue */ 2 :
        case /* FloatValue */ 3 :
          break;
      }
      const root = state.root;
      if (root !== undefined) {
        state.follow = true;
        bottom(Caml_option.valFromOption(root));
        return Curry._1(state.report, true);
      } else {
        return;
      }
    case "scope" :
      if (property.TAG !== /* StringValue */ 0) {
        return Stdlib.invalid_arg("invalid_anchor_property");
      }
      const scope = property._0;
      if (scope !== state.scope) {
        state.scope = scope;
        state.follow = true;
        state.older_armed = false;
        return Stdlib__Option.iter((function (root) {
          bottom(root);
          Curry._1(state.report, true);
        }), state.root);
      } else {
        return;
      }
    default:
      return Stdlib.invalid_arg("invalid_anchor_property");
  }
}

function adapter_web_extension_remove_property(param, param$1) {
  
}

function adapter_web_extension_cleanup(el) {
  el.__mapreAnchor.live = false;
  Curry._1(el.__mapreAnchorDispose.dispose, undefined);
}

const adapter = {
  web_extension_create: create,
  web_extension_set_property: set_property,
  web_extension_remove_property: adapter_web_extension_remove_property,
  web_extension_cleanup: adapter_web_extension_cleanup
};

function component(param) {
  return Lui_extension.component(identifier, {
    hd: {
      profile_os: /* WebOS */ 1,
      profile_host: /* WebHost */ 1
    },
    tl: /* [] */ 0
  }, false, /* [] */ 0, {
    hd: Lui_extension.property("scope", /* StringScalar */ 0, false, {
      TAG: /* StringValue */ 0,
      _0: ""
    }),
    tl: {
      hd: Lui_extension.property("force", /* IntScalar */ 2, false, {
        TAG: /* IntValue */ 2,
        _0: 0
      }),
      tl: /* [] */ 0
    }
  }, {
    hd: Lui_extension.$$event("pinned", {
      hd: Lui_extension.event_field("value", /* BoolScalar */ 1, true),
      tl: /* [] */ 0
    }),
    tl: {
      hd: Lui_extension.$$event("older", /* [] */ 0),
      tl: /* [] */ 0
    }
  });
}

function view(scope_signal, force_signal, on_older, on_pinned, context, parent) {
  const node = Lui_ui.extension(context, identifier);
  Lui_ui.extension_property_signal(context, node, "scope", Signal.map((function (scope) {
    return {
      TAG: /* StringValue */ 0,
      _0: scope
    };
  }), scope_signal));
  Lui_ui.extension_property_signal(context, node, "force", Signal.map((function (token) {
    return {
      TAG: /* IntValue */ 2,
      _0: token
    };
  }), force_signal));
  Lui_ui.on_event(context, node, (function (param) {
    if (param.TAG !== /* ExtensionEvent */ 22) {
      return;
    }
    const id = param._1;
    switch (param._2) {
      case "older" :
        if (id === identifier) {
          return Curry._1(on_older, undefined);
        } else {
          return;
        }
      case "pinned" :
        if (id !== identifier) {
          return;
        }
        const match = Curry._2(Lui_protocol.String_map.find_opt, "value", param._3);
        if (match !== undefined && match.TAG === /* BoolValue */ 1) {
          return Curry._1(on_pinned, match._0);
        } else {
          return;
        }
      default:
        return;
    }
  }));
  Stdlib__Option.iter((function (parent) {
    Lui_ui.append(context, parent, node);
  }), parent);
  return node;
}

export {
  identifier,
  component,
  adapter,
  view,
}
/* Lui_extension Not a pure module */
